<template>
    <div>
        <p>Hello [client],</p>
        <p>Thank you for your continued confidence and trust in Avalon. We remain committed to exceeding your
            expectations in every way.</p>
        <p>Attached is your annual invoice for the ongoing maintenance of our professional relationship. We kindly ask
            that you review the enclosed statement for detailed payment information. If you have any questions or need
            further clarification, please don't hesitate to contact your advisor.</p>
        <p>We sincerely appreciate your loyalty and support.</p>
        <p>
            Thank you,<br>
            Avalon Wealth Advisory
        </p>
    </div>
</template>

<script>
export default { }
</script>
